import React from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import UTModal from 'app/components/UTModal';
import UTRadioButton from 'app/components/UTRadioButton';
import { message } from 'utils/stringUtils';

import progressChartHelpPng from '../../../../assets/progressChartHelp.png';

import styles from './styles';

class HelpButton extends React.Component {
  state = { modalIsOpen: false };

  openModal = () => this.setState({ modalIsOpen: true });

  closeModal = () => this.setState({ modalIsOpen: false });

  render() {
    return (
      <div>
        <UTRadioButton onPress={this.openModal} />
        <UTModal imageModal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal}>
          <div style={styles.content}>
            <img alt="" src={progressChartHelpPng} style={styles.chart} />
            <UTLabel semibold style={styles.text}>
              {message('AccountStatus:calcExplanationOne')}
            </UTLabel>
            <UTLabel semibold style={styles.text}>
              {message('AccountStatus:calcExplanationTwo')}
            </UTLabel>
            <UTLabel semibold>2016: 3 + 5 + 4 + 8 + 6 = 26</UTLabel>
            <UTLabel semibold>2017: 8 + 6 + 10 + 6 + 4 = 34</UTLabel>
          </div>
        </UTModal>
      </div>
    );
  }
}

export default Radium(HelpButton);
